"use strict";

var _toConsumableArray = require("/codebuild/output/src073659321/src/turo-project/turo-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _toArray = require("/codebuild/output/src073659321/src/turo-project/turo-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EditorState_1 = __importDefault(require("../EditorState"));

var change_1 = __importDefault(require("./change"));

var constants_1 = require("../constants");

function undo(editorState) {
  if (editorState.undoStack.length === 0) {
    return editorState;
  }

  var _editorState$undoStac = _toArray(editorState.undoStack),
      lastChanges = _editorState$undoStac[0],
      rest = _editorState$undoStac.slice(1);

  var emptyChange = [];
  var newEditorState = new EditorState_1.default({
    start: editorState.start,
    end: editorState.end,
    list: editorState.list,
    redoStack: [emptyChange].concat(_toConsumableArray(editorState.redoStack)),
    undoStack: editorState.undoStack
  });
  newEditorState = lastChanges.reduce(function (editorState, lastChange) {
    var updated = change_1.default({
      current: editorState.list,
      change: Object.assign({}, lastChange, {
        start: lastChange.start - 1,
        end: lastChange.end - 1
      })
    });

    var _editorState$redoStac = _toArray(editorState.redoStack),
        lastRedo = _editorState$redoStac[0],
        redoStack = _editorState$redoStac.slice(1);

    return new EditorState_1.default({
      start: updated.change.start,
      end: updated.change.end,
      list: updated.current,
      redoStack: [[updated.change].concat(lastRedo || [])].concat(redoStack),
      undoStack: rest
    });
  }, newEditorState);
  return new EditorState_1.default({
    start: newEditorState.start - 1,
    lastChangeType: constants_1.COMMAND.UNDO,
    end: newEditorState.end - 1,
    list: newEditorState.list,
    redoStack: newEditorState.redoStack,
    undoStack: newEditorState.undoStack
  });
}

exports.default = undo;